<template>
  <div class="select-container">
    <label class="select-label" v-if="label">{{ label }}</label>
    <select
      class="select-css"
      :value="value"
      @input="updateValue"
      v-bind="$attrs"
      v-on="listeners"
    >
      <option
        v-for="option in options"
        :key="option.id"
        :selected="option.id === value"
        :value="option.id"
      >
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { formFieldMixin } from '@/mixins/formFieldMixin'
export default {
  mixins: [formFieldMixin],
  props: {
    options: {
      type: Array,
      required: true
    }
  }
}
</script>
<style scoped>
.select-container {
  margin-top: 50px;
  margin-bottom: 10px;
}
.select-label {
  color: white;
  font-weight: 700;
  font-size: 1.2em;
}

.select-css {
	box-shadow: 0 1px 0 1px rgba(0,0,0,.04);
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23ea1d75%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
	linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%);
}
.select-css::-ms-expand {
	display: none;
}
.select-css:hover {
	border-color: #fff;
}
.select-css:focus {
	border-color: #aaa;
	box-shadow: 0 0 1px 3px #ea1d75;
	box-shadow: 0 0 0 3px -moz-mac-focusring;
	color: #222; 
	outline: none;
}
.select-css option {
	font-weight:normal;
}
.select-css option:hover {
  background-color: red;
}  
</style>